<template>
  <div class="main-container">
    <div class="w3-margin-top block">
      <div class="w3-half">
        <router-link to="/">
          <img src="./img/logo.png">
        </router-link>
      </div>

      <div class="w3-container w3-half">
        <div class="w3-right w3-margin-top w3-margin-right">
          <div class="contact-row uppercase">Kérdésed van? Keress minket!</div>

          <div class="contact-row">
            <img class="contact-icon" src="./img/phone.svg">
            +36 20 330 0518
          </div>

          <div class="contact-row">
            <img class="contact-icon uppercase" src="./img/email.svg">
            info@becreative.glass
          </div>
        </div>
      </div>
    </div>

    <div class="w3-container">
      <h1 class="w3-xxlarge w3-center gradiant-text">
        Miért a becreative zuhanyzói?
      </h1>
    </div>

    <div class="w3-row-padding w3-section block">
      <div class="w3-col m12 l6 w3-container w3-center">
        <img class="img-shower" src="./img/shower.jpg">
      </div>

      <div class="w3-col m12 l6 w3-container card-container">
        <div class="w3-row w3-center card-row">
          <div class="w3-half card">
            <div class="w3-section card-cycle">
                <img class="icon-white" src="./img/paint-brush.svg">
                <img class="icon-gray" src="./img/gray_paint-brush.svg">
            </div>

            <h4>Egyedülálló design</h4>

            <div class="card-text">
              A megrendelő elképzelése szerint megvalósított, modern, printelt üvegfelület már a fürdőszobában is
            </div>
          </div>

          <div class="w3-half card">
            <div class="w3-section card-cycle">
              <img class="icon-white icon-larger" src="./img/safety.svg">
              <img class="icon-gray icon-larger" src="./img/gray_safety.svg">
            </div>

            <h4>Biztonságos üveg</h4>

            <div class="card-text">
              ESG üvegeinket az előírásoknak megfelelő MSZ EN 12150 szabvány szerint készítjük el
            </div>
          </div>
        </div>

        <div class="w3-row w3-center card-row">
          <div class="w3-half card">
            <div class="w3-section card-cycle">
              <img class="icon-white icon-margin-fix" src="./img/clean.svg">
              <img class="icon-gray icon-margin-fix" src="./img/gray_clean.svg">
            </div>

            <h4>Könnyen tisztítható</h4>

            <div class="card-text">
              Hagyományos fürdőszobai tisztítószerekkel tisztán tartható, kérésre ClearShield bevonattal ellátva
            </div>
          </div>

          <div class="w3-half card">
            <div class="w3-section card-cycle">
              <img class="icon-white" src="./img/quality.svg">
              <img class="icon-gray" src="./img/gray_quality.svg">
            </div>

            <h4>Minőségi kivitelezés</h4>

            <div class="card-text">
              Egyedi méretezés alapján, fürdőszobában alkalmazott szerelvényekkel, precízen beépítve
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w3-container gradiant-background" @click="$refs.subscribe.scrollIntoView({ behavior: 'smooth' })">
      <h1 class="w3-xxlarge w3-center">
        Ingyenes felmérés otthonodban!
      </h1>
    </div>

    <div class="w3-row list-main-container block">
      <div class="w3-margin-top w3-margin-bottom">
        <h1 class="w3-xxlarge w3-center gradiant-text">
          A tökéletes megvalósítás három lépésben
        </h1>
      </div>

      <div class="w3-row-padding list-container">
        <div class="w3-col m12 l6 w3-container">
          <div class="w3-col l5 m4 w3-hide-small w3-container list-cycle-container">
            <div class="list-lines-container">
              <img src="./img/line.svg">
            </div>

            <div class="list-cycle">1.</div>

            <div class="list-cycle">2.</div>

            <div class="list-cycle">3.</div>
          </div>

          <div class="w3-col l7 m6 w3-container">
            <div class="list-cycle w3-hide-medium w3-hide-large">1.</div>

            <div class="list-text-container">
              <h4>Ingyenes felmérés</h4>

              <p class="list-text">
                Miután kitöltötted a lap alján található
                űrlapot, munkatársunk felveszi
                veled a kapcsolatot!
              </p>
            </div>

            <div class="list-cycle w3-hide-medium w3-hide-large">2.</div>

            <div class="list-text-container">
              <h4>Árajánlat készítés</h4>

              <p class="list-text">
                Minden munka más-és más, ezért
                ügyfeleinknek személyre szabott
                árajánlatot készítünk.
              </p>
            </div>

            <div class="list-cycle w3-hide-medium w3-hide-large">3.</div>

            <div class="list-text-container">
              <h4>Kivitelezés</h4>

              <p class="list-text">
                Fontosnak tartjuk ügyfeleink
                elégedettségét, ezért a kivitelezés során
                többször is egyeztetünk.<br>
                <b>100% elégedettségi garancia</b>
              </p>
            </div>
          </div>
        </div>

        <div class="w3-col m12 l6 w3-container w3-center">
          <img class="printed-shower" src="./img/printed_shower.jpg">
        </div>
      </div>

      <vue-particles
        :particleSize="7"
        :particlesNumber="80"
        :linesDistance="200"
        :linesWidth="2"
        :moveSpeed="1.5"
      />
    </div>

    <div class="w3-row">
      <div class="w3-row reference-container">
        <div class="block">
          <div class="w3-container w3-margin">
              <h1 class="w3-xxlarge w3-center gradiant-text">
                Referenciák
              </h1>
            </div>

            <div class="w3-row-padding reference-img-container">
              <div v-for="(image, imageIndex) in referenceThumbnails">
                <img
                  :src="image"
                  @click="index = imageIndex"
                >
              </div>
            </div>
          </div>
        </div>

      <gallery
        :images="referenceImages"
        :index="index"
        @close="index = null"
        :options="{ displayClass: 'blueimp-gallery-display-fix' }"
      />
    </div>

    <div class="w3-row subscribe-container" ref="subscribe">
      <div class="block">
        <div class="w3-col m12 l6 subscribe-text-container">
          <div class="subscribe-text1 uppercase">Ingyenes</div>
          <div class="subscribe-text2 uppercase">Felmérés</div>
          <div class="subscribe-text3 uppercase">Otthonodban!</div>
        </div>

        <div class="w3-col m12 l6">
          <div class="form-container">
            <div class="form-text">
              Legyél az elsők között akinek<br>
              ingyenesen elvégezzük a felmérést!
            </div>

            <form ref="form" @submit.prevent="submit">
              <div class="w3-section">
                <input type="text" name="name" placeholder="Teljes név" required v-model="form.name">
              </div>

              <div class="w3-section">
                <input type="tel" name="phone" placeholder="Telefonszám" required v-model="form.phone">
              </div>

              <div class="w3-section">
                <input type="email" name="email" placeholder="E-mail cím" required v-model="form.email">
              </div>

              <div class="w3-section">
                <input type="number" min="1000" max="9999" name="zipcode" placeholder="Irányítószám" required v-model="form.zipcode">
              </div>

              <div ref="grecaptcha" class="g-recaptcha" :data-sitekey="rcaptSigKey"></div>

              <button-spinner
                :isLoading="isLoading"
                :disabled="isLoading"
                :status="status"
              >
                <span>Elküld</span>
              </button-spinner>

              <vue-toast ref="successToast"></vue-toast>
              <vue-toast ref="errorToast"></vue-toast>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Gallery from 'vue-gallery';
  import VueParticles from 'vue-particles';
  import ButtonSpinner from 'vue-button-spinner';
  import VueToast from 'vue-toast';

  Vue.use(VueParticles);

  const referenceThumbnails =
    require
    .context('static/images/landing_page/thumbnails', false, /\.(jpg)$/)
    .keys()
    .map(image => `static/images/landing_page/thumbnails/${image.substring(2)}`);

  const referenceImages =
    require
    .context('static/images/landing_page/', false, /\.(jpg)$/)
    .keys()
    .map(image => `static/images/landing_page/${image.substring(2)}`);

  export default {
    name: 'landingPage',
    data() {
      return {
        referenceImages,
        referenceThumbnails,
        index: null,
        form: {
          name: '',
          phone: '',
          email: '',
          zipcode: '',
        },
        isLoading: false,
        status: '',
        rcaptSigKey: '6LcBsmkUAAAAAKUzZ-GcEuc6j5w8xgSmkr-5s-Gy',
        rcaptId: 0,
      };
    },
    mounted() {
      this.initReCaptcha();

      this.$refs.errorToast
        .setOptions({
          position: 'bottom right',
          maxToasts: 2,
        });

      this.$refs.successToast
        .setOptions({
          position: 'bottom right',
          maxToasts: 2,
        });
    },
    methods: {
      initReCaptcha() {
        setTimeout(() => {
          if (!window.grecaptcha) {
            this.initReCaptcha();
          } else {
            this.rcaptId =
              window.grecaptcha
              .render(this.$refs.grecaptcha, { sitekey: this.rcaptSigKey });
          }
        }, 100);
      },
      submit: async function submit() {
        if (!window.grecaptcha) {
          this.$refs.errorToast
            .showToast(
              'Sikertelen küldés! Kérjük, próbálkozz újra később!', {
                theme: 'error',
                timeLife: '5000',
              });

          return;
        }

        const gRecaptchaResponse = window.grecaptcha.getResponse(this.rcaptId);

        if (this.isLoading || !gRecaptchaResponse) {
          return;
        }

        this.isLoading = true;

        const success = await this.$store.dispatch('sendSurveyReqMail', this.form);

        if (success) {
          this.form = {
            name: '',
            phone: '',
            email: '',
            zipcode: '',
          };

          window.grecaptcha.reset();
          this.isLoading = false;
          this.status = true;

          const toastMessage = `
          Köszönjük a megkeresést! Munkatársunk hamarosan felveszi veled a kapcsolatot!<br>
          <a href="/termekeink"> További termékeink megtekintése <a>`;

          this.$refs.successToast
            .showToast(toastMessage, {
              theme: 'success',
              closeBtn: true,
            });

          setTimeout(() => {
            this.status = '';
          }, 3000);

          return;
        }

        this.$refs.errorToast
          .showToast(
            'Sikertelen küldés! Kérjük, próbálkozz újra később!', {
              theme: 'error',
              timeLife: '5000',
            });

        window.grecaptcha.reset();
        this.isLoading = false;
        this.status = false;

        setTimeout(() => {
          this.status = '';
        }, 3000);
      },
    },
    components: {
      Gallery,
      ButtonSpinner,
      VueToast,
    },
  };

</script>

<style scoped>
  h1 {
    text-transform: uppercase;
    font-weight: 600;
    line-height: 1.2;
  }

  .uppercase {
    text-transform: uppercase;
  }

  h4 {
    font-weight: 600;
    color: #666666;
  }

  .main-container {
    margin: auto;
    padding-bottom: 140px;
  }

  .block {
    max-width: 1600px;
    margin: auto;
  }

  .contact-row {
    font-size: 20px;
    padding-bottom: 5px;
  }

  .contact-icon {
    width: 25px;
    margin-left: 5px;
    margin-right: 5px;
  }

  .gradiant-text {
    background: -webkit-linear-gradient(42deg, #f2514c, #fa326f);
    background: linear-gradient(42deg, #f2514c, #fa326f);
    color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
  }

  @media screen and (-ms-high-contrast: active),
  (-ms-high-contrast: none) {
    .gradiant-text {
      background: transparent;
      color: #fa326f;
    }
  }

  .img-shower {
    max-height: 550px;
    max-width: 100%;
  }

  .card-container {
    margin-top: 60px;
  }

  @media (max-width: 992px) {
    .card-row {
      margin: auto;
      max-width: 460px;
    }
  }

  @media (max-width: 509px) {
    .card-row {
      margin: auto;
      max-width: 220px;
    }
  }

  .card {
    position: relative;
    width: 210px;
    height: 230px;
    margin: 10px;
    color: #666666;
    box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.08);
  }

  .card:after {
    z-index: -1;
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    background: -webkit-linear-gradient(42deg, #fa326f, #f2514c);
    background: linear-gradient(42deg, #fa326f, #f2514c);
    opacity: 0;
    transition: all 0.4s ease-in-out;
  }

  .card:hover:after {
    opacity: 1;
  }

  .card:hover h4 {
    color: white;
  }

  .card:hover .card-text {
    color: white;
  }

  .card-cycle {
    position: relative;
    margin: auto;
    border-radius: 50%;
    width: 65px;
    height: 65px;
    background: -webkit-linear-gradient(42deg, #f2514c, #fa326f);
    background: linear-gradient(42deg, #f2514c, #fa326f);
    box-shadow: 0px 18px 35px 0px rgba(0, 0, 0, 0.28);
  }

  .card-cycle:after {
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    border-radius: 50%;
    background: white;
    opacity: 0;
    transition: all 0.4s ease-in-out;
  }

  .card:hover .card-cycle:after {
    opacity: 1;
  }

  .card-cycle img {
    width: 40px;
    margin-top: 13px;
  }

  .icon-larger {
    width: 45px !important;
    margin-top: 10px !important;
  }

  .icon-margin-fix {
    margin-top: 12px !important;
    margin-left: 2px;
  }

  .icon-gray {
    position: relative;
    z-index: 1;
    display: none;
  }

  .card:hover .icon-white {
    display: none;
  }

  .card:hover .icon-gray {
    display: inline;
  }

  .card h4 {
    transition: all 0.4s ease-in-out;
  }

  .card-text {
    font-weight: 300;
    font-size: 13px;
    transition: all 0.4s ease-in-out;
  }

  .gradiant-background {
    background: -webkit-linear-gradient(42deg, #f2514c, #fa326f);
    background: linear-gradient(42deg, #f2514c, #fa326f);
    color: white;
    margin: 40px 0 0 0;
    height: 145px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .list-container {
    margin-top: 40px;
    position: relative;
  }

  .list-cycle-container {
    position: relative;
  }

  .printed-shower {
    max-width: 600px;
    width: 100%;
  }

  .reference-container {
    background: #F0F0F0;
    padding: 20px 0 60px 0;
    margin-right: 0;
    margin-left: 0;
  }

  .reference-img-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .reference-img-container div {
    width: 300px;
    margin: 10px;
  }

  .reference-img-container div img {
    cursor: pointer;
    width: 100%;
  }

  .list-main-container {
    position: relative;
    padding-top: 40px;
    padding-bottom: 80px;
  }

  .list-cycle {
    border-radius: 50%;
    width: 65px;
    height: 65px;
    background: #232838;
    color: white;
    margin-top: 40px;
    margin-bottom: 80px;
    margin-left: auto;
    margin-right: 0;
    text-align: center;
    font-size: 23px;
    line-height: 63px;
    padding-left: 4px;
  }

  @media (max-width: 600px) {
    .list-cycle {
      margin: auto;
      line-height: 66px;
      padding-left: 5px;
    }
  }

  .list-text-container {
    margin-top: 50px;
    margin-bottom: 50px;
  }

  @media (max-width: 600px) {
    .list-text-container {
      margin: auto;
    }
  }

  .list-text {
    font-size: 13px;
  }

  .list-lines-container {
    position: absolute;
    top: 61px;
    right: -20px;
    z-index: -1;
  }

  .list-lines-container img {
    width: 139px;
  }

  #particles-js {
    z-index: -1;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }

  .subscribe-container {
    background: -webkit-linear-gradient(42deg, #f2514c, #fa326f);
    background: linear-gradient(42deg, #f2514c, #fa326f);
    color: white;
    padding-top: 40px;
    padding-bottom: 30px;
  }

  .form-text {
    text-align: center;
  }

  .subscribe-container input {
    width: 90%;
    border: none;
    border-radius: 50px;
    height: 35px;
    background: #F0F0F0;
    padding-left: 15px;
  }

  .subscribe-container button {
    width: 100px;
    border: none;
    border-radius: 50px;
    height: 31px;
    background: #F0F0F0;
    font-size: 12px;
    font-weight: bold;
  }

  .form-container {
    text-align: center;
  }

  form {
    padding-top: 20px;
    max-width: 500px;
    margin: auto;
  }

  .subscribe-text-container {
    margin-top: 40px;
  }

  @media (max-width: 992px) {
    .subscribe-text-container {
      margin-top: 0;
      margin-bottom: 30px;
    }
  }

  .subscribe-text1 {
    text-align: center;
    font-weight: 700;
    font-size: 50px;
    height: 57px;
    letter-spacing: 10px;
    padding-left: 11px;
  }

  .subscribe-text2 {
    text-align: center;
    font-size: 33px;
    height: 34px;
    letter-spacing: 19px;
    padding-left: 17px;
  }

  .subscribe-text3 {
    text-align: center;
    font-weight: 600;
    font-size: 38px;
    height: 46px;
  }

  .g-recaptcha {
    margin: auto;
    width: 304px;
    margin-bottom: 10px;
  }

  .vue-btn-loader-error {
    width: 100px !important;
    background: #F0F0F0 !important;
  }

  .vue-btn-loader-success {
    width: 100px !important;
    background: #F0F0F0 !important;
  }

</style>



// WEBPACK FOOTER //
// View.vue?353f50d5